import React from 'react';
import Lookup from 'src/componentes/select2';

const NivelProficienciaLookup = ({ ...rest }) => <Lookup labelKey="nome" valueKey="id" url="/NivelProficienciaLookup" {...rest} />;

export default NivelProficienciaLookup;
